import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import HealthEdit from './HealthEdit';

const Health = (props) => {
    console.log(props,"profdjskdfjskfjskfdjskdfjsd");
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
    <p></p>
    <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
        <DataField 
            editMode={false} 
            lg={12} 
            md={24} 
            options={props.ad.emp_health} 
            type="Select" 
            name="employee health" 
            value={data.emp_health_code} 
        />
        <DataField 
            editMode={false} 
            lg={12} 
            md={24} 
            name="value" 
            value={data.value} 
        />
    </Row>  
    <p></p>
</div>
            );
        })
           
        :
        <>
            <p></p>
            <HealthEdit options = {props.ad.emp_health} data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Health